<div class="employee-details">
  @if (firstName || lastName) {
    <span
      >{{ firstName }}
      {{ lastName }}
      <span>&nbsp;&mdash;&nbsp;</span>
    </span>
  }
  <span>Employee ID: {{ employeeId }}</span>
</div>
